import moment from 'moment-timezone';

import { Product } from 'models/product';
import { Reservation } from 'models/reservation';

export const getCheckinExpirationLimit = (reservation: Reservation, product: Product) => {
  if ((reservation?.checkin_info?.checkin_records || []).length === 0) {
    return null;
  }

  if (product?.qr_checkin_settings?.expiration_date?.relative_date?.type === 'ETERNAL') {
    return null;
  }

  const checkedInTime = moment.tz(
    reservation.checkin_info.checkin_records[0].date_time_utc,
    reservation.start_timezone || 'UTC'
  );

  if (product?.qr_checkin_settings?.expiration_date?.instant_expiration) {
    return checkedInTime;
  }

  if (product?.qr_checkin_settings?.expiration_date?.relative_date?.type === 'HOUR') {
    const count = product?.qr_checkin_settings?.expiration_date?.relative_date?.count ?? 0;
    return checkedInTime.add(count, 'h');
  }

  if (product?.qr_checkin_settings?.expiration_date?.relative_date?.type === 'DAY') {
    const count = product?.qr_checkin_settings?.expiration_date?.relative_date?.count ?? 0;
    const parts = (
      product?.qr_checkin_settings?.expiration_date?.relative_date?.time_local ?? '00:00'
    ).split(':');
    let hour = 0;
    let minute = 0;
    if (parts.length > 1) {
      hour = Number(parts[0]);
      minute = Number(parts[1]);
    }
    return checkedInTime
      .add(count, 'd')
      .set({ hour: hour, minute: minute, second: 0, millisecond: 0 });
  }

  return null;
};
